import PropTypes from 'prop-types';

export default function OutlineTag(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m17.52 11.525-5.986 5.985a1.67 1.67 0 0 1-2.363 0l-6.584-6.576A2 2 0 0 1 2 9.519V2.835C2 2.374 2.374 2 2.835 2H9.52a2 2 0 0 1 1.414.586L17.52 9.17a1.67 1.67 0 0 1 0 2.354Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path
                d="M6.174 6.174h.01"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineTag.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
